export default class ResultsFilter {
	constructor(offers, selectedEvents) {
		this.offers = _.cloneDeep(offers);
		this.selectedEvents = _.uniq([...selectedEvents, 27]);
	}

	getOrderedResults(orderBy) {
		if (this.offers === null) {
			return null;
		}

		let results = {
			missing: {},
			all: {},
		};

		const filtered = _.filter(this.offers, offer => offer.success);

		if (orderBy !== null) {
			return {
				all: _.orderBy(filtered, orderBy.orderBy, orderBy.direction),
				missing: {},
			};
		}

		let grouped = _.groupBy(
			filtered,
			offer => {
				return _.map(
					_.filter(offer.insurance_events, event => event.included),
					filtered => filtered.name,
				);
			},
			'desc',
		);
		let ordered = _.orderBy(
			grouped,
			offer => _.filter(offer[0].insurance_events, event => event.included).length,
			'desc',
		);

		_.each(ordered, (offers, key) => {
			const offersIncludedEventsIds = _.map(
				_.filter(offers[0].insurance_events, event => event.included),
				event => event.id,
			);

			if (offersIncludedEventsIds.length > this.selectedEvents.length) {
				this.selectedEvents = [
					...this.selectedEvents,
					..._.difference(offersIncludedEventsIds, this.selectedEvents),
				];
			}

			if (_.isEqual(_.sortBy(offersIncludedEventsIds), _.sortBy(this.selectedEvents))) {
				_.assign(
					results.all,
					orderBy !== null ? _.orderBy(offers, orderBy.orderBy, orderBy.direction) : offers,
				);
			} else {
				const missings = _.differenceWith(this.selectedEvents, offersIncludedEventsIds, _.isEqual);

				offers.missings = missings;

				_.assign(results.missing, {
					[key]:
						orderBy !== null
							? _.assign(_.orderBy(offers, orderBy.orderBy, orderBy.direction), { missings })
							: offers,
				});
			}
		});

		return results;
	}
}
